var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProjectStructure',{scopedSlots:_vm._u([{key:"sidebar-left",fn:function(){return [_c('div',{staticClass:"color-white-04"},[_vm._v(" "+_vm._s(_vm.$t('Project.Structure.SpatialStructure.Header'))+" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"uploadIFC",attrs:{"type":"file","accept":".ifc"},on:{"change":function($event){return _vm.selectIFC(_vm.$refs.uploadIFC.files[0])}}})]),_c('div',{staticStyle:{"position":"relative","padding-bottom":"30px"}},[_c('ProjectStructureTree',{attrs:{"isEditMode":_vm.isEditMode && _vm.select_spatial_el_ta_id === -1,"parent":_vm.project,"child_elements":_vm.getChildElements({parent_type: 'projects', parent_id: _vm.project_id}),"selected_tree_element":_vm.$route.name === 'ProjectStructureDetails'?{type: _vm.$route.params.type, id: _vm.$route.params.structure_id}:false,"all_selected_elements":_vm.getAllSelectedElements({project_id: _vm.project_id}),"train_selected_elements":_vm.select_spatial_el_train_id !== -1?_vm.getAllSelectedElements({project_id: _vm.project_id, train_id: _vm.select_spatial_el_train_id}):[],"ta_selected_elements":_vm.select_spatial_el_ta_id !== -1?_vm.getUObject({type: 'taktareas', id: _vm.select_spatial_el_ta_id}).elements:[],"ta_hovered_elements":_vm.hover_ta_id !== -1?_vm.getUObject({type: 'taktareas', id: _vm.hover_ta_id}).elements:[],"select_spatial_el_ta_id":_vm.select_spatial_el_ta_id,"hover_el_id":_vm.hover_el_id,"parent_color_index":0},on:{"closeWrapper":function($event){return _vm.updateUDObject({
          url: [
            {[$event.type]: $event.id},
          ],
          update: {
            closed: !$event.closed
          }
        })},"draggableUpdate":function($event){_vm.updateUObject({
          url: [
            {[$event.evt.item.id.split('#')[0]]: $event.evt.item.id.split('#')[1]},
          ],
          url_prefix: `/projects/${_vm.project_id}/projectstructure`,
          update: {
            order_index: ($event.evt.newIndex + ($event.evt.newIndex > $event.evt.oldIndex?1:0)) * 10 + 5
          },
        }).then(() => {
          _vm.updateTreeOrderIndex($event.parent)
          })},"draggableRemove":function($event){_vm.updateUObjectParent({
              url: [
                {[$event.evt.from.id.split('#')[0]]: parseInt($event.evt.from.id.split('#')[1])},
                {[$event.evt.item.id.split('#')[0]]: parseInt($event.evt.item.id.split('#')[1])},
                {changeparent: ''}
              ],
              url_prefix: `/projects/${_vm.project_id}/projectstructure`,
              update: {
                target_type: $event.evt.to.id.split('#')[0],
                target_id: parseInt($event.evt.to.id.split('#')[1]),
                parent: {
                  type: $event.evt.to.id.split('#')[0],
                  id: parseInt($event.evt.to.id.split('#')[1])
                }
              },

            }).then(() => {
              _vm.updateUObject({
                  url: [
                    {[$event.evt.item.id.split('#')[0]]: parseInt($event.evt.item.id.split('#')[1])},
                  ],
                  url_prefix: `/projects/${_vm.project_id}/projectstructure`,
                  update: {
                    order_index: $event.evt.newIndex * 10 + 5,
                    /* parent: {type: $event.evt.to.id.split('#')[0], id: $event.evt.to.id.split('#')[1]} */
                  }
                }).then(() => {
                  _vm.updateUDObject({
                      url: [
                        {[$event.evt.item.id.split('#')[0]]: parseInt($event.evt.item.id.split('#')[1])},
                      ],
                      url_prefix: `/projects/${_vm.project_id}/projectstructure`,
                      update: {
                        parent: {type: $event.evt.to.id.split('#')[0], id: $event.evt.to.id.split('#')[1]}
                      }
                    }).then(() => {
                      _vm.updateTreeOrderIndex($event.parent)
                      })
                })
          })},"draggableAdd":function($event){return _vm.updateTreeOrderIndex($event.parent)},"clickAddElement":function($event){_vm.createUObject({
          url: [
            {[$event.parent.type]: $event.parent.id},
            {[$event.element.type]: ''},
            {showWithEntitiesNormalized: ''}
          ],
          url_prefix: `/projects/${_vm.project_id}/projectstructure`,
          u_object: JSON.parse(JSON.stringify(Object.assign(_vm.spatial_containers.concat(_vm.spatial_elements).find(el => el.name === $event.element.name), {order_index: 5, parent: {type: $event.parent.type, id: $event.parent.id}})))
          }).then(() => {
            _vm.updateTreeOrderIndex($event.parent)
            })},"deleteTreeElement":function($event){_vm.removeElementsFromTaktareas({
          type: $event.type,
          id: $event.id,
          }).then(() => {
            _vm.deleteUObject({
              url: [
                {[$event.parent.type]: $event.parent.id},
                {[$event.type]: $event.id}
              ],
              url_prefix: `/projects/${_vm.project_id}/projectstructure`,
            })
          })},"changeValue":function($event){return _vm.updateUObject({
            url: [
              {[$event.element.type]: $event.element.id}
            ],
            url_prefix: `/projects/${_vm.project_id}/projectstructure`,
            update: {
              [$event.key]: $event.value
            }
          })},"addElement":function($event){return _vm.addUObjects({
            url: [
              {projects: _vm.project_id},
              {trains: 0},
              {taktareas: _vm.select_spatial_el_ta_id},
              {add: ''}
            ],
            u_objects: {
              target_type: 'elements',
              target_ids: [$event.id]
            }
          })},"removeElement":function($event){return _vm.removeUObjects({
            url: [
              {projects: _vm.project_id},
              {trains: 0},
              {taktareas: _vm.select_spatial_el_ta_id},
              {remove: ''}
            ],
            u_objects: {
              target_type: 'elements',
              target_ids: [$event.id]
            }
          })},"enterElement":function($event){return _vm.elMouseEnter($event)},"leaveElement":function($event){return _vm.elMouseLeave()},"treeElementClicked":function($event){_vm.isEditMode && _vm.select_spatial_el_ta_id !== -1 && $event.type !== 'elements'?
        _vm.selectAllSpatialContainerElements(_vm.getAllChildElements({
          parent_type: $event.type,
          parent_id: $event.id,
        })):''}}})],1)]},proxy:true},(_vm.isEditMode && _vm.select_spatial_el_ta_id === -1)?{key:"sidebar-left-footer",fn:function(){return [_c('draggable',{attrs:{"group":{name: 'spatial_containers', pull: 'clone', put: false},"sort":false,"animation":"300","forceFallback":"true","fallbackOnBody":"true","value":_vm.spatial_containers},on:{"end":function($event){_vm.createUObject({
        url: [
          {[$event.to.id.split('#')[0]]: $event.to.id.split('#')[1]},
          {[$event.item.id.split('#')[0]]: ''},
          {showWithEntitiesNormalized: ''}
        ],
        url_prefix: `/projects/${_vm.project_id}/projectstructure`,
        u_object: JSON.parse(JSON.stringify(Object.assign(_vm.spatial_containers[$event.oldIndex], {order_index: $event.newIndex * 10 + 5, parent: {type: $event.to.id.split('#')[0], id: parseInt($event.to.id.split('#')[1])}})))
        })}}},_vm._l((_vm.spatial_containers),function(element){return _c('v-chip',{key:element.name,staticClass:"mr-1",staticStyle:{"cursor":"grab"},attrs:{"id":element.type+'#-1',"color":"rgb(30,30,30)"}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.getElementsIcon(element.type)))]),(_vm.$route.name === 'ProjectStructure')?_c('div',{staticClass:"ml-1"},[_vm._v(_vm._s(element.name))]):_vm._e()],1)}),1),_c('draggable',{attrs:{"group":{name: 'spatial_elements', pull: 'clone', put: false},"sort":false,"animation":"300","forceFallback":"true","fallbackOnBody":"true","value":_vm.spatial_elements},on:{"end":function($event){_vm.createUObject({
        url: [
          {[$event.to.id.split('#')[0]]: $event.to.id.split('#')[1]},
          {[$event.item.id.split('#')[0]]: ''},
          {showWithEntitiesNormalized: ''}
        ],
        url_prefix: `/projects/${_vm.project_id}/projectstructure`,
        u_object: JSON.parse(JSON.stringify(Object.assign(_vm.spatial_elements[$event.oldIndex], {order_index: $event.newIndex * 10 + 5, parent: {type: $event.to.id.split('#')[0], id: parseInt($event.to.id.split('#')[1])}})))
        })}}},_vm._l((_vm.spatial_elements),function(element){return _c('v-chip',{key:element.name,staticClass:"mr-1",staticStyle:{"cursor":"grab"},attrs:{"id":element.type+'#-1',"color":"rgb(30,30,30)"}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.getElementsIcon(element.type)))]),(_vm.$route.name === 'ProjectStructure')?_c('div',{staticClass:"ml-1"},[_vm._v(_vm._s(element.name))]):_vm._e()],1)}),1)]},proxy:true}:null,{key:"main",fn:function(){return [_c('router-view')]},proxy:true},{key:"sidebar-right",fn:function(){return [_c('div',{staticClass:"color-white-04",staticStyle:{"position":"sticky","left":"0px"}},[_vm._v(_vm._s(_vm.$t('Project.Structure.ProcessStructure.Header')))]),_c('draggable',{staticStyle:{"position":"relative","padding-bottom":"30px"},attrs:{"id":`projects#${_vm.project_id}`,"group":{name: 'trains', pull: false, put: function (to, from, dragEl) {return ['trains'].includes(dragEl.id.split('#')[0])}},"animation":"300","forceFallback":"true","fallbackOnBody":"true","disabled":!_vm.isEditMode || _vm.select_spatial_el_ta_id !== -1,"value":_vm.project.trains,"filter":".ignore"},on:{"start":function($event){_vm.dragging = true},"end":function($event){_vm.dragging = false},"update":function($event){return _vm.updateUObjectPosition({
          url: [
          {projects: _vm.project_id},
          {trains: _vm.project.trains[$event.oldIndex]},
          ],
          update: {
            position: $event.newIndex - $event.oldIndex
          }
        })},"add":function($event){return _vm.$router.push({
          name: 'ProjectStructureAddTrain',
          params: {
            project_id: _vm.project_id,
            train_index: $event.newIndex,
            train_id: _vm.project.trains[$event.newIndex],
            direction: 0,
          }
        })}}},[_vm._l((_vm.getUObjects({type: 'trains', ids: _vm.project.trains})),function(train){return _c('ProjectStructureTrain',{key:train.id,attrs:{"train":train,"isEditMode":_vm.isEditMode && _vm.select_spatial_el_ta_id === -1},on:{"closeTrain":function($event){return _vm.updateUDObject({
          url: [
            {projects: _vm.project_id},
            {trains: train.id}
          ],
          update: {
            closed: !train.closed
          }
        })},"changeValue":function($event){return _vm.updateUObject({
            url: [
              {projects: _vm.project_id},
              {trains: train.id},
            ],
            update: {
              [$event.key]: $event.value
            }
          })}},scopedSlots:_vm._u([{key:"actions",fn:function(){return [(!train.closed)?_c('v-btn',{staticStyle:{"height":"20px"},attrs:{"small":""},on:{"click":function($event){return _vm.toggleAllTaktareas(train)}}},[_c('div',[_vm._v(_vm._s(_vm.getUObject({type: 'taktareas', id: train.taktareas[0]}).closed?'open':'close')+" all")])]):_vm._e(),(_vm.isEditMode && _vm.select_spatial_el_ta_id === -1)?_c('StandardDeleteButton',{staticClass:"ml-2",attrs:{"zoom":0.8},on:{"clickDelete":function($event){return _vm.deleteUObject({
              url: [
                {projects: _vm.project_id},
                {trains: train.id},
              ],
            })}}}):_vm._e()]},proxy:true},{key:"body",fn:function(){return [_c('draggable',{staticStyle:{"position":"relative","padding-bottom":"30px"},attrs:{"id":`trains#${train.id}`,"group":{name: 'taktareas', pull: false, put: function (to, from, dragEl) {return ['taktareas'].includes(dragEl.id.split('#')[0])}},"animation":"300","forceFallback":"true","fallbackOnBody":"true","disabled":!_vm.isEditMode || _vm.select_spatial_el_ta_id !== -1,"value":train.taktareas},on:{"start":function($event){_vm.dragging = true},"end":function($event){_vm.dragging = false},"update":function($event){return _vm.updateUObjectPosition({
              url: [
              {projects: _vm.project_id},
              {trains: train.id},
              {taktareas: train.taktareas[$event.oldIndex]},
              ],
              update: {
                position: $event.newIndex - $event.oldIndex
              }
              })},"add":function($event){_vm.createUObject({
            url: [
              {projects: _vm.project_id},
              {trains: train.id},
              {taktareas: 'copytaktareabulk'},
              {showWithEntitiesNormalized: ''}
            ],
            u_object: {
              taktarea_copy: $event.newIndex === 0?train.taktareas[0]:train.taktareas[$event.newIndex-1],
              taktareas: [{
                taktarea_start: _vm.getUObject({type: 'taktareas', id: $event.newIndex === 0?train.taktareas[0]:train.taktareas[$event.newIndex-1]}).taktarea_start + parseInt(1),
                position: $event.newIndex + parseInt(1)

                }]
            }
            })}}},[_vm._l((_vm.getUObjects({type: 'taktareas', ids: train.taktareas})),function(taktarea){return _c('ProjectStructureTaktarea',{key:taktarea.id,attrs:{"taktarea":taktarea,"isEditMode":_vm.isEditMode && _vm.select_spatial_el_ta_id === -1,"hover":_vm.hover_ta_id === taktarea.id,"hover_el_id":_vm.hover_el_id},on:{"closeTaktarea":function($event){return _vm.updateUDObject({
              url: [
                {projects: _vm.project_id},
                {trains: train.id},
                {taktareas: taktarea.id},
              ],
              update: {
                closed: !taktarea.closed
              }
            })},"changeValue":function($event){return _vm.updateUObject({
                url: [
                  {projects: _vm.project_id},
                  {trains: train.id},
                  {taktareas: taktarea.id},
                ],
                update: {
                  [$event.key]: $event.value
                }
              })}},nativeOn:{"mouseenter":function($event){_vm.dragging?'':_vm.taMouseEnter(taktarea)},"mouseleave":function($event){_vm.dragging?'':_vm.taMouseLeave()}},scopedSlots:_vm._u([{key:"waggons",fn:function(){return _vm._l((_vm.getUObjects({type: 'twaggons', ids: taktarea.twaggons})),function(waggon){return _c('Waggon',{key:`waggon${waggon.id}`,attrs:{"workpackage_count":waggon.tworkpackages.length,"zoom":0.5},scopedSlots:_vm._u([{key:"content",fn:function(){return _vm._l((_vm.getUObjects({type: 'tworkpackages', ids: waggon.tworkpackages})),function(workpackage){return _c('WorkPackage',{key:`workpackage${workpackage.id}`,attrs:{"workpackage_count":waggon.tworkpackages.length,"workpackage":workpackage,"zoom":0.5}})})},proxy:true}],null,true)})})},proxy:true},{key:"delete",fn:function(){return [(_vm.isEditMode && _vm.select_spatial_el_ta_id === -1)?_c('StandardDeleteButton',{staticClass:"ml-2",attrs:{"zoom":0.8},on:{"clickDelete":function($event){_vm.hover_ta_id = -1,
                _vm.deleteUObject({
                    url: [
                      {projects: _vm.project_id},
                      {trains: train.id},
                      {taktareas: taktarea.id},
                    ],
                  })}}}):_vm._e()]},proxy:true},{key:"body",fn:function(){return [_vm._l((_vm.getUObjects({type: 'elements', ids: taktarea.elements})),function(element){return _c('ProjectStructureTaktareaElement',{key:`element${element.id}`,attrs:{"element":element}})}),(_vm.isEditMode)?_c('v-btn',{class:_vm.select_spatial_el_ta_id === taktarea.id?'green lighten-1':'',staticStyle:{"height":"20px"},attrs:{"small":""},on:{"click":function($event){_vm.select_spatial_el_ta_id === taktarea.id?
                (_vm.select_spatial_el_ta_id = -1, _vm.select_spatial_el_train_id = -1) : (_vm.select_spatial_el_ta_id = taktarea.id, _vm.select_spatial_el_train_id = train.id)}}},[(_vm.select_spatial_el_ta_id === taktarea.id)?_c('div',[_c('v-icon',{attrs:{"small":""}},[_vm._v("done")]),_vm._v("done")],1):_c('div',[_c('v-icon',{attrs:{"small":""}},[_vm._v("add")]),_vm._v("select")],1)]):_vm._e()]},proxy:true}],null,true)})}),(_vm.isEditMode)?_c('TFlex',{staticClass:"ignore",staticStyle:{"position":"absolute","bottom":"0px","font-style":"italic","color":"rgba(0,0,0,0.4)","margin-left":"24px"}},[_c('div',{staticStyle:{"overflow":"hidden","white-space":"nowrap"}},[_vm._v("Drop or Select:")]),_c('v-chip',{staticClass:"ml-2",staticStyle:{"cursor":"pointer"},attrs:{"color":"rgba(0,0,0, 0.2)","small":""},on:{"click":function($event){_vm.createUObject({
                url: [
                  {projects: _vm.project_id},
                  {trains: train.id},
                  {taktareas: 'copytaktareabulk'},
                  {showWithEntitiesNormalized: ''}
                ],
                u_object: {
                  taktarea_copy: train.taktareas[train.taktareas.length-1],
                  taktareas: [{
                    taktarea_start: _vm.getUObject({type: 'taktareas', id: train.taktareas[train.taktareas.length-1]}).taktarea_start + parseInt(1),
                    position: train.taktareas.length-1 + parseInt(1)
                    }]
                }
                })}}},[_c('div',{staticStyle:{"color":"rgba(255,255,255,0.7)"}},[_vm._v("Taktarea")])])],1):_vm._e()],2)]},proxy:true}],null,true)})}),(_vm.isEditMode)?_c('TFlex',{staticClass:"ignore",staticStyle:{"position":"absolute","bottom":"0px","font-style":"italic","color":"rgba(0,0,0,0.4)"}},[_c('div',{staticStyle:{"overflow":"hidden","white-space":"nowrap"}},[_vm._v("Drop or Select:")]),_c('v-chip',{staticClass:"ml-2",staticStyle:{"cursor":"pointer"},attrs:{"color":"rgba(0,0,0, 0.2)","small":""},on:{"click":function($event){return _vm.$router.push({
              name: 'ProjectStructureAddTrain',
              params: {
                project_id: _vm.project_id,
                train_index: 0,
                train_id: _vm.project.trains[0],
                direction: 0,
              }
            })}}},[_c('div',{staticStyle:{"color":"rgba(255,255,255,0.7)"}},[_vm._v("Train")])])],1):_vm._e()],2)]},proxy:true},(_vm.isEditMode && _vm.select_spatial_el_ta_id === -1)?{key:"sidebar-right-footer",fn:function(){return [_c('draggable',{attrs:{"group":{name: 'process_structure', pull: 'clone', put: false},"sort":false,"animation":"300","forceFallback":"true","fallbackOnBody":"true","value":_vm.process_structure_elements}},_vm._l((_vm.process_structure_elements),function(element){return _c('v-chip',{key:element.name,staticClass:"mr-1",staticStyle:{"cursor":"grab"},attrs:{"id":element.type+'#-1',"color":"rgb(30,30,30)"}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.getElementsIcon(element.type)))]),(_vm.$route.name === 'ProjectStructure')?_c('div',{staticClass:"ml-1"},[_vm._v(_vm._s(element.name))]):_vm._e()],1)}),1)]},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }